import React from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import { testIdGen } from '../../utils/testIdGen.esm.js';
import { TruncateText } from '../TruncateText/TruncateText.esm.js';
import { Bold } from './Bold.esm.js';

const sizeVariants = {
    sm: "tw-text-xs tw-leading-normal tw-tracking-wide tw-font-semibold",
    lg: "tw-text-sm tw-font-semibold",
};
/**
 * A subordinate title that provides additional information about the content on a page or in a section.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { Subtitle } from "@panwds/react-ui";
 * ```
 */
function Subtitle({ addClassName, as = "span", children, dataMetrics, dataTestId, size = "sm", truncate = false, ...passThrough }) {
    const className = classNames("tw-font-lato tw-box-border tw-m-0 tw-p-0 tw-border-0", sizeVariants[size], truncate && "tw-flex", addClassName);
    return (React.createElement(Bold, { "data-metrics": dataMetrics, "data-testid": dataTestId ||
            `subtitle-${typeof children === "string" && testIdGen(children)}`, as: as, addClassName: className, appearance: "semibold", ...passThrough }, truncate ? React.createElement(TruncateText, null, children) : children));
}

export { Subtitle };
//# sourceMappingURL=Subtitle.esm.js.map
